import React from 'react';
import AboutUsImg from "./images/aboutus.jpg";
import './css/aboutus.css';
import { useLanguage } from '../context/LanguageContext';

const AboutUs = () => {
    const { t, languageData } = useLanguage();
    const isRTL = languageData.dir === 'rtl';
    
    return (
        <section id="about-section" className='about-us'>
              <div className='section-header'>
                    <h1> {t('aboutUs.title')} </h1>
                </div>
            <div className='container'>
              
                <div className='row'>
                    <div className='col-lg-4 col-md-5 col-sm-12 col-12'>
                        <div className='img'>
                            <img src={AboutUsImg} alt='about us image' />
                        </div>
                    </div>

                    <div className='col-lg-4 col-md-5 col-sm-12 col-12'>
                        <div className='text'>
                            <div className='para'>
                                {!isRTL ? (
                                    <>
                                        <span aria-hidden="true"> </span>
                                        <p> {t('aboutUs.paragraph1')} </p>
                                    </>
                                ) : (
                                    <>
                                        <p> {t('aboutUs.paragraph1')} </p>
                                        <span aria-hidden="true"> </span>
                                    </>
                                )}
                            </div>

                            <div className='para'>
                                {!isRTL ? (
                                    <>
                                        <span aria-hidden="true"> </span>
                                        <p> {t('aboutUs.paragraph2')} </p>
                                    </>
                                ) : (
                                    <>
                                        <p> {t('aboutUs.paragraph2')} </p>
                                        <span aria-hidden="true"> </span>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutUs
